var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 189,
    viewBox: "0 0 195 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(0 0)",
    fill: "#3c4e71"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3969",
    "data-name": "Group 3969",
    transform: "translate(-150 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    "data-name": "Group 1859",
    transform: "translate(-707.769 927.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957",
    "data-name": "Group 3957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3956",
    "data-name": "Group 3956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953",
    "data-name": "Group 3953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3952",
    "data-name": "Group 3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951",
    "data-name": "Group 3951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16045",
    "data-name": "Path 16045",
    d: "M94.5,0A94.5,94.5,0,1,1,0,94.5,94.5,94.5,0,0,1,94.5,0Z",
    transform: "translate(857.769 -579.026)",
    fill: "#1f4a88"
  })))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    "data-name": "Group 1858",
    transform: "translate(857.769 -579.026)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M1018.109-328.228a29.372,29.372,0,0,1,7-4.6q13.191-7.2,26.388-14.4a12.277,12.277,0,0,0,6.921-11.723c-.045-3.52-.018-7.041,0-10.561a2.175,2.175,0,0,0-.462-1.415,65.069,65.069,0,0,1-11.373-23.615,1.7,1.7,0,0,0-.683-1,9.342,9.342,0,0,1-4-7.3c-.159-4.969-.2-9.945.025-14.914a8.913,8.913,0,0,1,2.7-5.849,1.684,1.684,0,0,0,.549-1.266c-.016-6.007.105-12.017-.054-18.02a32.432,32.432,0,0,1,1.192-10.8c2.43-7.667,7.579-12.817,14.866-15.944a48.585,48.585,0,0,1,18.1-3.532c7.1-.193,14.112.325,20.862,2.754,6.235,2.243,11.372,5.9,14.684,11.784a27.285,27.285,0,0,1,3.346,15.085c-.156,3.125-.057,6.263-.063,9.4-.006,3.068.007,6.137-.009,9.2a1.663,1.663,0,0,0,.5,1.287,9.054,9.054,0,0,1,2.784,6.309c.063,4.81.157,9.628-.029,14.431-.162,4.17-2.51,7-6.3,8.623a1.46,1.46,0,0,0-.926.979,70.573,70.573,0,0,1-12.248,22.569,1.537,1.537,0,0,0-.325,1.07c.009,4-.06,8.011.029,12.014a11.234,11.234,0,0,0,6.24,10.313c7.628,3.974,15.36,7.749,23.048,11.607,3.082,1.546,6.169,3.08,9.241,4.644a21.232,21.232,0,0,1,4.847,3.315,7.335,7.335,0,0,1-.72.778,101.7,101.7,0,0,1-17.889,11.632,94.985,94.985,0,0,1-16.147,6.453,98.636,98.636,0,0,1-18.267,3.667c-.9.09-8.533.577-10.267.534a107.345,107.345,0,0,1-15.668-1.234,98.767,98.767,0,0,1-27.64-8.708,103.454,103.454,0,0,1-19.256-12.3A2.238,2.238,0,0,1,1018.109-328.228Z",
    transform: "translate(-987.028 493.713)",
    fill: "#a4bac6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3899",
    "data-name": "Group 3899",
    transform: "translate(0 -10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_344",
    "data-name": "Ellipse 344",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(307 478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3929",
    "data-name": "Group 3929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3928",
    "data-name": "Group 3928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3927",
    "data-name": "Group 3927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3926",
    "data-name": "Group 3926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3925",
    "data-name": "Group 3925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3923",
    "data-name": "Group 3923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3921",
    "data-name": "Group 3921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3913",
    "data-name": "Group 3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3911",
    "data-name": "Group 3911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3910",
    "data-name": "Group 3910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3909",
    "data-name": "Group 3909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3908",
    "data-name": "Group 3908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3907",
    "data-name": "Group 3907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906",
    "data-name": "Group 3906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3904",
    "data-name": "Group 3904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903",
    "data-name": "Group 3903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3902",
    "data-name": "Group 3902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901",
    "data-name": "Group 3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900",
    "data-name": "Group 3900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3968",
    "data-name": "Group 3968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3967",
    "data-name": "Group 3967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966",
    "data-name": "Group 3966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3965",
    "data-name": "Group 3965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3964",
    "data-name": "Group 3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963",
    "data-name": "Group 3963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962",
    "data-name": "Group 3962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3961",
    "data-name": "Group 3961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16044",
    "data-name": "Path 16044",
    d: "M5967.068,2312.546v-1.2a.388.388,0,0,0,.042-.1,4.982,4.982,0,0,1,3.076-4c.418-.183.669-.348.57-.825a.147.147,0,0,1,0-.046,5.135,5.135,0,0,1,6.087-4.64.378.378,0,0,0,.422-.149,5.694,5.694,0,0,1,5.833-2.009,5.8,5.8,0,0,1,4.546,6.287.307.307,0,0,0,.173.345,5.727,5.727,0,0,1,2.815,5.016,5.845,5.845,0,0,1-4.424,5.689c-.271.069-.547.12-.821.18h-13.765a.662.662,0,0,0-.124-.043,5.148,5.148,0,0,1-4.3-3.936C5967.153,2312.929,5967.111,2312.737,5967.068,2312.546Zm11.8-7.163-4.36,4.355h2.87v4.4h2.954v-4.416h2.876Z",
    transform: "translate(-5653.312 -1811.65)",
    fill: "#072042"
  })))))))))))))))))))))))))))))))))))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuser);
export default __webpack_public_path__ + "static/media/Duser.427e82a0898b830f7353e402dbd9d71e.svg";
export { ForwardRef as ReactComponent };